export default "__VITE_ASSET__83695345__"